import { useState, useCallback } from 'react';
import { BaseContact } from '../../../api/CoachingNotes/schema';
import { PastContact } from '../../../api/PastContacts/schema';
import { QueryVariablesContactListeningData } from '../../../api/Naws';

export interface UsePlaybackModalResult {
  selectedContact: BaseContact | undefined;
  playbackModalOpen: boolean;
  contactListeningParams: QueryVariablesContactListeningData | undefined;
  handlePlayClick: (pastContact: PastContact) => void;
  setContactListeningParams: (
    params: QueryVariablesContactListeningData
  ) => void;
  handleModalToggle: (isOpen: boolean) => void;
}

export const usePlaybackModal = (): UsePlaybackModalResult => {
  const [selectedContact, setSelectedContact] = useState<
    BaseContact | undefined
  >(undefined);
  const [playbackModalOpen, setPlaybackModalOpen] = useState<boolean>(false);
  const [contactListeningParams, setContactListeningParams] =
    useState<QueryVariablesContactListeningData>();

  const handlePlayClick = useCallback((pastContact: PastContact) => {
    setSelectedContact({
      contactID: pastContact.COMM_ID,
      contactDate: pastContact.TIME,
    });
    setPlaybackModalOpen(true);
  }, []);

  const handleModalToggle = useCallback((isOpen: boolean) => {
    setPlaybackModalOpen(isOpen);
    if (!isOpen) {
      setSelectedContact(undefined);
    }
  }, []);

  return {
    selectedContact,
    playbackModalOpen,
    contactListeningParams,
    handlePlayClick,
    setContactListeningParams,
    handleModalToggle,
  };
};
